import type { FaireProductEntity } from "../../entity_types/product";

export const p_jz9gugwpcy: FaireProductEntity = {
  token: "p_jz9gugwpcy",
  type: "product",
  name: "TEAM CHARM NECKLACE-HOGS CARDINAL",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl:
    "https://cdn.faire.com/fastly/dec55f9f7933e0cfff74a63b596d878f9d0be8caf67e7be742beaa0c50f2caf3.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.16,
  description:
    "Bring bold team spirit to your style with the playful Team Charm Necklace – Hogs Cardinal! Perfect as a scarf charm or fun accessory, it adds a splash of color and cheer wherever you go.\n",
  tags: [],
  msrpDollars: 26.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:48.361Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
